import { Navigate, useLocation } from "react-router-dom";
import type { JSX } from "react";
import { JWT_NAME } from "../constants/constants";

// Guards authenticated routes: with no session token, redirect to /login (remembering where the
// user was trying to go). Real authorization is still enforced server-side; this just avoids
// rendering authed pages that would only 401.
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const token = sessionStorage.getItem(JWT_NAME);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
